import { closeAllSubMenus } from './navigation';
const toggleButton = document.querySelector('.site-search__toggle');
const searchForm = document.querySelector('.site-search__form');
const searchInput = document.querySelector('.site-search__input');
function init() {
    toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.addEventListener('click', () => {
        toggleButton.ariaExpanded === 'true' ? hideSearchForm() : showSearchForm();
    });
}
init();
export function showSearchForm() {
    closeAllSubMenus();
    toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.setAttribute('aria-expanded', 'true');
    searchForm === null || searchForm === void 0 ? void 0 : searchForm.removeAttribute('hidden');
    searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
}
export function hideSearchForm() {
    searchForm === null || searchForm === void 0 ? void 0 : searchForm.setAttribute('hidden', '');
    toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.setAttribute('aria-expanded', 'false');
}
